import type { Practitioner } from '@medplum/fhirtypes';
import type { MedplumClient } from '@medplum/core';
import { PRACTITIONER_USER_EMAIL_IDENTIFIER_SYSTEM } from '../pages/appointments/fhirNoteMapping';

type Profile = { resourceType: string; telecom?: Array<{ system?: string; value?: string }> } | undefined;

/**
 * Resolves the current user to their Practitioner resource for signing flows.
 * 1) If profile is already a Practitioner, returns it.
 * 2) Otherwise searches by identifier (system + email from profile.telecom).
 * Same deterministic key as the seed script uses for demo Practitioners.
 */
export async function resolveCurrentUserPractitioner(
  medplum: MedplumClient,
  profile: Profile,
): Promise<Practitioner | null> {
  if (profile?.resourceType === 'Practitioner') {
    return profile as Practitioner;
  }
  const email = profile?.telecom?.find((t) => t.system === 'email')?.value;
  if (!email?.trim()) return null;
  const identifier = `${PRACTITIONER_USER_EMAIL_IDENTIFIER_SYSTEM}|${email.trim()}`;
  const results = await medplum.searchResources('Practitioner', { identifier, _count: '1' });
  return results[0] ?? null;
}
